module.exports = __webpack_public_path__ + "media/assets/images/contact_details-7d4917ffab8b2775ff7c75db25fc9d92.svg";